/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Common_Somethingwentwrong3Inputs */

const id_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjadi kesalahan`)
};

const ms_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesuatu tidak kena`)
};

const da_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noget gik galt`)
};

const de_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen`)
};

const en_us2_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const es_es2_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal`)
};

const es_mx2_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal`)
};

const fil_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May maling nangyari`)
};

const fr_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite`)
};

const it_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto`)
};

const hu_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valami hiba történt`)
};

const nl_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is iets misgegaan`)
};

const no_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noe gikk galt`)
};

const pl_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś poszło nie tak`)
};

const pt_br2_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado`)
};

const pt_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal`)
};

const ro_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceva nu a mers bine`)
};

const fi_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokin meni pieleen`)
};

const sv_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Något gick fel`)
};

const vi_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xảy ra lỗi`)
};

const tr_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir şeyler ters gitti`)
};

const cs_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Něco se pokazilo`)
};

const bg_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нещо се обърка`)
};

const ru_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так`)
};

const uk_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щось пішло не так`)
};

const ar_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ ما`)
};

const hi_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुछ गलत हो गया`)
};

const th_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาด`)
};

const ja_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラーが発生しました`)
};

const zh_cn2_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出错了`)
};

const zh_hant1_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生錯誤`)
};

const ko_offerdetail_common_somethingwentwrong3 = /** @type {(inputs: Offerdetail_Common_Somethingwentwrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문제가 발생했습니다`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Offerdetail_Common_Somethingwentwrong3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_common_somethingwentwrong3 = /** @type {((inputs?: Offerdetail_Common_Somethingwentwrong3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Common_Somethingwentwrong3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "ms") return ms_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "da") return da_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "de") return de_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "fil") return fil_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "fr") return fr_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "it") return it_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "hu") return hu_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "nl") return nl_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "no") return no_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "pl") return pl_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "pt") return pt_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "ro") return ro_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "fi") return fi_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "sv") return sv_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "vi") return vi_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "tr") return tr_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "cs") return cs_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "bg") return bg_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "ru") return ru_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "uk") return uk_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "ar") return ar_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "hi") return hi_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "th") return th_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "ja") return ja_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_common_somethingwentwrong3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_common_somethingwentwrong3(inputs)
	return ko_offerdetail_common_somethingwentwrong3(inputs)
});
export { offerdetail_common_somethingwentwrong3 as "offerDetail.common.somethingWentWrong" }